"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable max-len */
// values in this file are never directly used in components but set the 'base theme' properties

/*
  This file defines our color pallet.
  Most colors will have support for 10 shades.
  New shades should be slotted in only when necessary.
  If you think you need to add a new color, please raise a flag.
 */
// ============== //
// Primary Colors //
// 10 shades      //
// ============== //
var primary = {
  _primaryColor100: {
    category: 'Primary',
    baseKey: '_primaryColor100',
    dataType: 'color',
    commonUses: ['Secondary and tertiary button background on hover'],
    value: '#E7F4EE'
  },
  _primaryColor200: {
    category: 'Primary',
    baseKey: '_primaryColor200',
    dataType: 'color',
    commonUses: [''],
    value: '#B9DECE'
  },
  _primaryColor300: {
    category: 'Primary',
    baseKey: '_primaryColor300',
    dataType: 'color',
    commonUses: [''],
    value: '#8BC8AE'
  },
  _primaryColor400: {
    category: 'Primary',
    baseKey: '_primaryColor400',
    dataType: 'color',
    commonUses: [''],
    value: '#5CB38E'
  },
  _primaryColor500: {
    category: 'Primary',
    baseKey: '_primaryColor500',
    dataType: 'color',
    commonUses: ['Primary button background when active'],
    value: '#2E9D6E'
  },
  _primaryColor600: {
    category: 'Primary',
    baseKey: '_primaryColor600',
    dataType: 'color',
    commonUses: ['Primary brand color', 'Primary button background at rest', 'Secondary and tertiary button text at rest', 'Secondary and tertiary button background when active', 'Informational call-outs'],
    value: '#00884E'
  },
  _primaryColor700: {
    category: 'Primary',
    baseKey: '_primaryColor700',
    dataType: 'color',
    commonUses: ['Primary button background on hover'],
    value: '#005732'
  },
  _primaryColor800: {
    category: 'Primary',
    baseKey: '_primaryColor800',
    dataType: 'color',
    commonUses: [''],
    value: '#003E24'
  },
  _primaryColor900: {
    category: 'Primary',
    baseKey: '_primaryColor900',
    dataType: 'color',
    commonUses: [''],
    value: '#002616'
  },
  _primaryColor1000: {
    category: 'Primary',
    baseKey: '_primaryColor1000',
    dataType: 'color',
    commonUses: [''],
    value: '#010D08'
  }
}; // ==================== //
// Secondary Colors     //
// 10 shades - 2 in use //
// ==================== //

var secondary = {
  _secondaryColor100: {
    category: 'Secondary',
    baseKey: '_secondaryColor100',
    dataType: 'color',
    commonUses: ['placeholder for future use'],
    value: undefined
  },
  _secondaryColor200: {
    category: 'Secondary',
    baseKey: '_secondaryColor200',
    dataType: 'color',
    commonUses: ['placeholder for future use'],
    value: undefined
  },
  _secondaryColor300: {
    category: 'Secondary',
    baseKey: '_secondaryColor300',
    dataType: 'color',
    commonUses: ['placeholder for future use'],
    value: undefined
  },
  _secondaryColor400: {
    category: 'Secondary',
    baseKey: '_secondaryColor400',
    dataType: 'color',
    commonUses: ['placeholder for future use'],
    value: undefined
  },
  _secondaryColor500: {
    category: 'Secondary',
    baseKey: '_secondaryColor500',
    dataType: 'color',
    commonUses: ['placeholder for future use'],
    value: undefined
  },
  _secondaryColor600: {
    category: 'Secondary',
    baseKey: '_secondaryColor600',
    dataType: 'color',
    commonUses: ['Used only on the CRUD List Item component'],
    value: '#238478'
  },
  _secondaryColor700: {
    category: 'Secondary',
    baseKey: '_secondaryColor700',
    dataType: 'color',
    commonUses: ['Used only on the CRUD List Item component'],
    value: '#1C6B61'
  },
  _secondaryColor800: {
    category: 'Secondary',
    baseKey: '_secondaryColor800',
    dataType: 'color',
    commonUses: ['placeholder for future use'],
    value: undefined
  },
  _secondaryColor900: {
    category: 'Secondary',
    baseKey: '_secondaryColor900',
    dataType: 'color',
    commonUses: ['placeholder for future use'],
    value: undefined
  },
  _secondaryColor1000: {
    category: 'Secondary',
    baseKey: '_secondaryColor1000',
    dataType: 'color',
    commonUses: ['placeholder for future use'],
    value: undefined
  }
}; // ========= //
// Greys     //
// 10 shades //
// ========= //

var greys = {
  _greyColor100: {
    category: 'Greys',
    baseKey: '_greyColor100',
    dataType: 'color',
    commonUses: ['Background for all disabled buttons'],
    value: '#EFEFF0'
  },
  _greyColor200: {
    category: 'Greys',
    baseKey: '_greyColor200',
    dataType: 'color',
    commonUses: [''],
    value: '#D1D1D2'
  },
  _greyColor300: {
    category: 'Greys',
    baseKey: '_greyColor300',
    dataType: 'color',
    commonUses: ['Disabled text when over light backgrounds'],
    value: '#B2B2B4'
  },
  _greyColor400: {
    category: 'Greys',
    baseKey: '_greyColor400',
    dataType: 'color',
    commonUses: [''],
    value: '#949497'
  },
  _greyColor500: {
    category: 'Greys',
    baseKey: '_greyColor500',
    dataType: 'color',
    commonUses: [''],
    value: '#757579'
  },
  _greyColor600: {
    category: 'Greys',
    baseKey: '_greyColor600',
    dataType: 'color',
    commonUses: ['Default font color', 'Text for all disabled buttons'],
    value: '#57575C'
  },
  _greyColor700: {
    category: 'Greys',
    baseKey: '_greyColor700',
    dataType: 'color',
    commonUses: [''],
    value: '#48484C'
  },
  _greyColor800: {
    category: 'Greys',
    baseKey: '_greyColor800',
    dataType: 'color',
    commonUses: [''],
    value: '#38383B'
  },
  _greyColor900: {
    category: 'Greys',
    baseKey: '_greyColor900',
    dataType: 'color',
    commonUses: [''],
    value: '#28282A'
  },
  _greyColor1000: {
    category: 'Greys',
    baseKey: '_greyColor1000',
    dataType: 'color',
    commonUses: [''],
    value: '#18181A'
  }
}; // ========== //
// CTA Colors //
// 5 shades   //
// ========== //

var cta = {
  _ctaColor100: {
    category: 'CTA',
    baseKey: '_ctaColor100',
    dataType: 'color',
    commonUses: [''],
    value: '#FDEDF1'
  },
  _ctaColor200: {
    category: 'CTA',
    baseKey: '_ctaColor200',
    dataType: 'color',
    commonUses: [''],
    value: '#FACBD5'
  },
  _ctaColor300: {
    category: 'CTA',
    baseKey: '_ctaColor300',
    dataType: 'color',
    commonUses: ['CTA button background when active', 'CTA inverted button background when active'],
    value: '#F7A9B9'
  },
  // _ctaColor400: {
  //   category: 'CTA',
  //   baseKey: '_ctaColor400',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  // _ctaColor500: {
  //   category: 'CTA',
  //   baseKey: '_ctaColor500',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  _ctaColor600: {
    category: 'CTA',
    baseKey: '_ctaColor600',
    dataType: 'color',
    commonUses: ['CTA button background at rest', 'CTA inverted button background on hover', 'Important text elements'],
    value: '#EE4266'
  },
  _ctaColor700: {
    category: 'CTA',
    baseKey: '_ctaColor700',
    dataType: 'color',
    commonUses: ['CTA button background on hover'],
    value: '#C33754'
  },
  _ctaColor800: {
    category: 'CTA',
    baseKey: '_ctaColor800',
    dataType: 'color',
    commonUses: [''],
    value: '#982A41'
  } // _ctaColor900: {
  //   category: 'CTA',
  //   baseKey: '_ctaColor900',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  // _ctaColor1000: {
  //   category: 'CTA',
  //   baseKey: '_ctaColor1000',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },

}; // ================== //
// Information Colors //
// 5 shades           //
// ================== //

var info = {
  _infoColor100: {
    category: 'Info',
    baseKey: '_infoColor100',
    dataType: 'color',
    commonUses: [''],
    value: '#E9F2F6'
  },
  _infoColor200: {
    category: 'Info',
    baseKey: '_infoColor200',
    dataType: 'color',
    commonUses: [''],
    value: '#BDD9E5'
  },
  _infoColor300: {
    category: 'Info',
    baseKey: '_infoColor300',
    dataType: 'color',
    commonUses: [''],
    value: '#92BFD3'
  },
  // _infoColor400: {
  //   category: 'Info',
  //   baseKey: '_infoColor400',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  // _infoColor500: {
  //   category: 'Info',
  //   baseKey: '_infoColor500',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  _infoColor600: {
    category: 'Info',
    baseKey: '_infoColor600',
    dataType: 'color',
    commonUses: [''],
    value: '#1E73A0'
  },
  _infoColor700: {
    category: 'Info',
    baseKey: '_infoColor700',
    dataType: 'color',
    commonUses: [''],
    value: '#176083'
  },
  _infoColor800: {
    category: 'Info',
    baseKey: '_infoColor800',
    dataType: 'color',
    commonUses: [''],
    value: '#104A66'
  } // _infoColor900: {
  //   category: 'Info',
  //   baseKey: '_infoColor900',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  // _infoColor1000: {
  //   category: 'Info',
  //   baseKey: '_infoColor1000',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },

}; // ============== //
// Warning Colors //
// 5 shades       //
// ============== //

var warning = {
  _warningColor100: {
    category: 'Warning',
    baseKey: '_warningColor100',
    dataType: 'color',
    commonUses: [''],
    value: '#FEFAEE'
  },
  _warningColor200: {
    category: 'Warning',
    baseKey: '_warningColor200',
    dataType: 'color',
    commonUses: [''],
    value: '#FDEAB8'
  },
  _warningColor300: {
    category: 'Warning',
    baseKey: '_warningColor300',
    dataType: 'color',
    commonUses: [''],
    value: '#FDE7AD'
  },
  // _warningColor400: {
  //   category: 'Warning',
  //   baseKey: '_warningColor400',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  // _warningColor500: {
  //   category: 'Warning',
  //   baseKey: '_warningColor500',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  _warningColor600: {
    category: 'Warning',
    baseKey: '_warningColor600',
    dataType: 'color',
    commonUses: [''],
    value: '#FBCB4B'
  },
  _warningColor700: {
    category: 'Warning',
    baseKey: '_warningColor700',
    dataType: 'color',
    commonUses: [''],
    value: '#CEA73E'
  },
  _warningColor800: {
    category: 'Warning',
    baseKey: '_warningColor800',
    dataType: 'color',
    commonUses: [''],
    value: '#A08130'
  } // _warningColor900: {
  //   category: 'Warning',
  //   baseKey: '_warningColor900',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  // _warningColor1000: {
  //   category: 'Warning',
  //   baseKey: '_warningColor1000',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },

}; // ============= //
// danger Colors //
// 5 shades      //
// ============= //

var danger = {
  _dangerColor100: {
    category: 'Danger',
    baseKey: '_dangerColor100',
    dataType: 'color',
    commonUses: [''],
    value: '#F9EDED'
  },
  _dangerColor200: {
    category: 'Danger',
    baseKey: '_dangerColor200',
    dataType: 'color',
    commonUses: [''],
    value: '#EEC9C9'
  },
  _dangerColor300: {
    category: 'Danger',
    baseKey: '_dangerColor300',
    dataType: 'color',
    commonUses: [''],
    value: '#F6A0A0'
  },
  // _dangerColor400: {
  //   category: 'Danger',
  //   baseKey: '_dangerColor400',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  // _dangerColor500: {
  //   category: 'Danger',
  //   baseKey: '_dangerColor500',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  _dangerColor600: {
    category: 'Danger',
    baseKey: '_dangerColor600',
    dataType: 'color',
    commonUses: [''],
    value: '#C43939'
  },
  _dangerColor700: {
    category: 'Danger',
    baseKey: '_dangerColor700',
    dataType: 'color',
    commonUses: [''],
    value: '#A12F2F'
  },
  _dangerColor800: {
    category: 'Danger',
    baseKey: '_dangerColor800',
    dataType: 'color',
    commonUses: [''],
    value: '#7D2525'
  } // _dangerColor900: {
  //   category: 'Danger',
  //   baseKey: '_dangerColor900',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },
  // _dangerColor1000: {
  //   category: 'Danger',
  //   baseKey: '_dangerColor1000',
  //   dataType: 'color',
  //   commonUses: ['not approved for use'],
  //   value: undefined,
  // },

}; // ======= //
// Whites  //
// 1 shade //
// ======= //

var whites = {
  _white: {
    category: 'Whites',
    baseKey: '_white',
    dataType: 'color',
    commonUses: ['Standard color for text over dark backgrounds'],
    value: '#FFFFFF'
  }
}; // ============================================================ //
// Masks                                                        //
// currently two different masks with the intent to reduce to 1 //
// ============================================================ //

var masks = {
  _mask100: {
    category: 'Masks',
    baseKey: '_mask100',
    dataType: 'color',
    commonUses: ['Light overlay used primarily for the spinner when content is loading'],
    value: 'rgba(255,255,255,.1);'
  },
  // a shade of grey is intentionally used here as it allows us to mute everything below the overlay
  // using black with an opacity of .2 does not mute black text
  _mask600: {
    category: 'Masks',
    baseKey: '_mask600',
    dataType: 'color',
    commonUses: ['Grey, heavily masking overlay used primarily with modals'],
    value: 'rgba(100,100,100,.9);'
  }
}; // ============================================================ //
// Data Grid                                                    //
// Used by the dataGrid ONLY - do not reuse until patterns      //
//    around this color are nailed down                         //
// ============================================================ //

var dataGrids = {
  _dataGrid600: {
    category: 'Data Grids',
    baseKey: '_dataGrid600',
    dataType: 'color',
    commonUses: ['Only used as the background for the DataGrid component'],
    value: '#E1E4EA'
  }
};

var _default = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, primary), secondary), cta), greys), info), warning), danger), whites), masks), dataGrids); // https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors


exports.default = _default;